import flatten from 'flat'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { useDebounce } from 'react-use'

export const ScrollToError = () => {
	const { errors, submitCount } = useFormikContext()

	const element = useMemo(() => {
		if (isEmpty(errors) || submitCount < 1) {
			return
		}

		const name = Object.keys(flatten(errors))?.[0]
		return document.getElementById(name)
	}, [errors, submitCount])

	useDebounce(
		() => {
			if (typeof element?.scrollIntoView === 'function') {
				element.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}
		},
		500,
		[submitCount]
	)

	return null
}
